export interface Event {
  id: string;
  slug: string;
  title: string;
  date: string;
  location: string;
  format: 'Virtual' | 'In-person' | 'Hybrid';
  description: string;
  agenda?: string[];
  speakers?: Array<{ name: string; title: string; company: string }>;
}

export const events: Event[] = [
  {
    id: '1',
    slug: 'bcbh-launch-ceremony',
    title: 'BCBH Launch Ceremony & MoU Signing',
    date: '2025-03-26',
    location: 'Cairo, Egypt',
    format: 'In-person',
    description: 'Official launch of the BUSAN–CAIRO BUSINESS HUB with MoU signing ceremony between BTEC, LOHMANN ECCE, and BTP.',
    agenda: [
      'Welcome remarks',
      'MoU signing ceremony',
      'Partner presentations',
      'Networking session',
    ],
    speakers: [
      { name: 'Representative', title: 'Chairman', company: 'BTEC' },
      { name: 'Representative', title: 'CEO', company: 'LOHMANN ECCE' },
      { name: 'Representative', title: 'Director', company: 'BTP' },
    ],
  },
  {
    id: '2',
    slug: 'korea-egypt-tech-forum',
    title: 'Korea–Egypt Technology Exchange Forum',
    date: '2025-05-15',
    location: 'Busan, South Korea',
    format: 'Hybrid',
    description: 'A forum focusing on technology transfer, innovation partnerships, and collaboration opportunities between Korean and Egyptian tech companies.',
    agenda: [
      'Keynote: Technology trends',
      'Panel: Cross-border innovation',
      'Company presentations',
      'B2B matchmaking',
    ],
    speakers: [
      { name: 'Tech Expert', title: 'CTO', company: 'Korean Tech Corp' },
      { name: 'Innovation Lead', title: 'Director', company: 'Egyptian Tech Hub' },
    ],
  },
  {
    id: '3',
    slug: 'wastewater-solutions-webinar',
    title: 'Wastewater Management Solutions Webinar',
    date: '2025-06-10',
    location: 'Virtual',
    format: 'Virtual',
    description: 'Exploring wastewater treatment technologies and opportunities for Korean solutions in the Egyptian market.',
    agenda: [
      'Market overview',
      'Technology showcase',
      'Q&A session',
    ],
    speakers: [
      { name: 'Water Expert', title: 'Senior Engineer', company: 'Korean Water Solutions' },
    ],
  },
  {
    id: '4',
    slug: 'infrastructure-workshop',
    title: 'Infrastructure Development Workshop',
    date: '2025-04-20',
    location: 'Cairo, Egypt',
    format: 'In-person',
    description: 'Workshop on infrastructure projects, tenders, and joint venture opportunities.',
    agenda: [
      'Project presentations',
      'Tender process overview',
      'JV formation guidance',
    ],
    speakers: [
      { name: 'Infrastructure Specialist', title: 'Project Manager', company: 'LOHMANN ECCE' },
    ],
  },
  {
    id: '5',
    slug: 'cairo-networking-reception',
    title: 'Cairo Networking Reception',
    date: '2025-04-05',
    location: 'Cairo, Egypt',
    format: 'In-person',
    description: 'Informal networking event for BCBH members and prospective partners.',
    agenda: [
      'Welcome drinks',
      'Networking',
      'Brief BCBH update',
    ],
    speakers: [],
  },
  {
    id: '6',
    slug: 'busan-business-mission',
    title: 'Busan Business Mission',
    date: '2025-07-08',
    location: 'Busan, South Korea',
    format: 'In-person',
    description: 'Business mission to Busan for Egyptian companies exploring Korean partnerships.',
    agenda: [
      'Company visits',
      'B2B meetings',
      'Cultural exchange',
    ],
    speakers: [],
  },
];

export const upcomingEvents = events.filter((e) => new Date(e.date) >= new Date());
export const pastEvents = events.filter((e) => new Date(e.date) < new Date());

